'use client'

import { useEffect, useState } from 'react'

interface ImgOnloadFallbackOptions {
  imageURL: string
  override?: boolean // override, if true return early
}

/**
 * Returns a boolean indicating if the image has loaded.
 */
export function useImgOnloadFallback({ imageURL, override }: ImgOnloadFallbackOptions) {
  const [loadedURL, setLoadedURL] = useState<string | null>(null)
  const imageLoaded = loadedURL === imageURL

  useEffect(() => {
    // If override is true, return early
    if (!imageURL || override) return
    const img = new window.Image()
    img.onload = () => {
      // If the image is smaller than 20x20, it's not usable
      const isUsable = img.naturalWidth >= 20 && img.naturalHeight >= 20
      setLoadedURL(isUsable ? imageURL : null)
    }
    img.onerror = () => setLoadedURL(null)
    img.src = imageURL
    return () => {
      img.onload = null
      img.onerror = null
    }
  }, [imageURL, override])

  return { imageLoaded }
}
